import { render } from "./form.vue?vue&type=template&id=7fea0d12&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=7fea0d12&lang=scss&scoped=true"
import "./form.vue?vue&type=style&index=1&id=7fea0d12&lang=scss"
script.render = render
script.__scopeId = "data-v-7fea0d12"

export default script